import React from "react";
import PlatformOnlyNotice from "@/component/commom/platform-only-notice";
import controllerIcon from "@public/img/controller.svg";

export default function GamePage() {
  return (
    <PlatformOnlyNotice
      title="بازی"
      icon={controllerIcon}
      iconAlt="بازی"
    />
  );
}
